<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal.form-elem_short
        .form-elem__title Документ удостоверящий личность
        .form-elem__main
          .input {{docType}}
    .form__elem(
    v-if="priorityDocument"
    )
      .form-elem.form-elem_horizontal
        .form-elem__title Номер
        .form-elem__main
          .input {{birthCertificate}}
    .form__elem(
    v-if="priorityDocument"
    )
      .form-elem.form-elem_horizontal.form-elem_short
        .form-elem__title Копия
        .form-elem__main
          .attach-file
            .attach-file__list
              .attach-file__item(
              v-for="file in birthCertificateAttachments"
              )
                .attached-file
                  a.button(
                  download="true"
                  :href="file.file"
                  )
                    .button__icon
                      img(src="@/assets/images/icons/doc.svg")
                    .button__text {{ file.name }}
    .form__elem(
      v-if="!priorityDocument"
    )
      .form-elem.form-elem_horizontal
        .form-elem__title Серия и номер
        .form-elem__main
          .input {{localPassport}}
    .form__elem.form__elem_short(
    v-if="!priorityDocument"
    )
      .form-elem.form-elem_horizontal
        .form-elem__title Дата выдачи
        .form-elem__main
          .input {{localPassportIssueDate}}
    .form__elem(
    v-if="!priorityDocument"
    )
      .form-elem.form-elem_horizontal.form-elem_short
        .form-elem__title Копия
        .form-elem__main
          .attach-file
            .attach-file__list
              .attach-file__item(
              v-for="file in passportAttachments"
              )
                .attached-file
                  a.button(
                  download="true"
                  :href="file.file"
                  )
                    .button__icon
                      img(src="@/assets/images/icons/doc.svg")
                    .button__text {{ file.name }}
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  name: "operator-form-docs",
  components: {
    //      AttachFile,
    DatePicker,
  },
  props: {
    priorityDocument: {
      type: Boolean,
      default: false,
    },

    //паспорт
    passport: {
      type: [String, Number],
      default: "",
    },
    passportIssueDate: {
      type: [String, Object],
      default: null,
    },
    passportAttachments: {
      type: Array,
      default: () => [],
    },

    //свидетельство
    birthCertificate: {
      type: String,
      default: "",
    },
    birthCertificateAttachments: {
      type: Array,
      default: () => [],
    },

    //снилс
    snils: {
      type: String,
      default: "",
    },
    snilsAttachments: {
      type: Array,
      default: () => [],
    },
    //инн
    inn: {
      type: String,
      default: "",
    },
    innAttachments: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    docType() {
      if (this.priorityDocument) {
        return "Свидетельство о рождении";
      } else {
        return "Паспорт";
      }
    },
    localPassport() {
      let block_1 = this.passport.slice(0, 4);
      let block_2 = this.passport.slice(4);
      return block_1 + " " + block_2;
    },
    localPassportIssueDate() {
      let date = null;
      date = this.passportIssueDate.split("-");
      date = date.reverse();
      date = date.join(".");
      return date;
    },
  },
};
</script>
